<template>
  <b-row>
    <b-col cols="12">

      <!-- PERMISSION TABLE -->
      <b-card no-body class="border">

        <div v-if="requestPending" class="loading_page" style=" padding: 10px;">
          <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        <b-card-header class="p-1">
          <b-card-title class="font-medium-2">
            <feather-icon icon="LockIcon" size="18" />
            <span class="align-middle ml-50">{{ $t('Link Devices to Region') }} - {{ $store.state.geofence.data.name
            }}</span>
          </b-card-title>
        </b-card-header>


        <devices-filter :owner-filter.sync="ownerFilter" :group-filter.sync="groupFilter" :type-filter.sync="typeFilter"
          :category-filter.sync="categoryFilter" :contract-filter.sync="contractFilter" :groups-options="groupsOptions"
          :contract-options="contractsOptions" :categories-options="categoriesOptions" :types-options="typesOptions"
          :owners-options="ownersOptions">
        </devices-filter>


        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col cols="12" md="6">

              <b-button type="submit" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="submit">
                {{ $t('Save Changes') }}
              </b-button>
            </b-col>
            <b-col cols="12" md="2" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{ $t('entries') }}</label>
            </b-col>



            <!-- Search -->
            <b-col cols="12" md="4">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')" />
              </div>
            </b-col>


          </b-row>


        </div>
        <b-table striped responsive class="mb-0" :items="devicesTb" :fields="fields">
          <template #head(action)="data">
            <b-form-checkbox v-model="isAllChecked" @change="checkAll(data, $event)" />
          </template>

          <template #cell(name)="data">
            {{ data.value }}
          </template>

          <template #cell()="data">
            <b-form-checkbox :state="devicesTb.includes(data.item.device_id) ? true : null"
              :checked="requestIds.includes(data.item.device_id)" @change="change(data, $event)" />
          </template>

        </b-table>

        <div class="mx-2 mb-2">
          <b-row>

            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">
                {{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{ $t('of') }} {{ dataMeta.of }}
                {{ $t('entries-devices') }}
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <b-pagination v-model="currentPage" :total-rows="totalTable" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-col>




  </b-row>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia, BPagination,
  BMediaAside,
  BMediaBody,
  BLink, BBadge,
  BImg,
  BTable, BFormCheckbox, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
import { OrbitSpinner } from 'epic-spinners'
import Ripple from 'vue-ripple-directive'
import { ref, computed, watch, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import geofenceStoreModule from '@/views/modules/geofence/geofenceStoreModule'
import usePermissions from '@/views/modules/user/users-edit/permissions/usePermissions'
import DevicesFilter from '@/views/modules/geofence/geofence-edit/DevicesFilter'

export default {
  components: {
    BButton, BForm, BImg, BFormFile,
    BFormGroup, BFormInput, BRow,
    BCol, BAlert, BCard, BCardText, BBadge,
    BMedia, BMediaAside, BMediaBody, vSelect, BPagination,
    BLink, BTable, BFormCheckbox, BCardTitle, BCardHeader, DevicesFilter, OrbitSpinner
  },
  directives: {
    Ripple,
  },


  setup(props, { root, emit }) {
    const isAllChecked = ref(false)
    const current_selected = ref([])
    const requestPending = ref(false)
    const devicesTb = ref([])
    const devicesAssociated = ref([])

    const ownersOptions = ref([])
    const groupsOptions = ref([])
    const typesOptions = ref([])
    const contractsOptions = ref([])
    const categoriesOptions = ref([])


    const ownerFilter = ref(null)
    const typeFilter = ref(null)
    const groupFilter = ref(null)
    const contractFilter = ref(null)
    const categoryFilter = ref(null)

    const geofenceData = computed(() => store.state.geofence.data)

    // console.log(geofenceData)


    const {
      perPage,
      perPageOptions,
      searchQuery,
      currentPage,
      totalTable,
      dataMeta } = usePermissions()

    const filter = ref({})

    watch([currentPage, perPage, searchQuery, ownerFilter, typeFilter,
      groupFilter, categoryFilter, contractFilter], () => {
        filter.value = {
          ...(ownerFilter.value && { owner: ownerFilter.value }),
          ...(groupFilter.value && { group: groupFilter.value }),
          ...(typeFilter.value && { type: typeFilter.value }),
          ...(contractFilter.value && { contract: contractFilter.value }),
          ...(categoryFilter.value && { category: categoryFilter.value }),
          ...(searchQuery.value && { q: searchQuery.value })
        }


        fetchDevicesTb()

      })
    const checkAll = (data, value) => {

      // if (value) requestIds.value = devicesTb.value.map((v) => v.id)
      if (value) {
        devicesTb.value.map(item => {
          if (requestIds.value.indexOf(item.device_id) == -1) {
            requestIds.value.push(item.device_id)
          }
        })
        requestIds.value.map((v) => {

          if (current_selected.value.indexOf(v) < 0) {
            current_selected.value.push(v)
          }
        })

      } else {
        devicesTb.value.map(item => {
          const index = current_selected.value.indexOf(item.device_id)

          if (index !== -1) current_selected.value.splice(index, 1)
        })


      }
      //  requestIds.value = []
      requestIds.value = JSON.parse(JSON.stringify(current_selected.value))

    }

    const GEOFENCE_DEVICES_STORE_MODULE_NAME = 'app-geofence-device'

    if (!store.hasModule(GEOFENCE_DEVICES_STORE_MODULE_NAME))
      store.registerModule(GEOFENCE_DEVICES_STORE_MODULE_NAME, geofenceStoreModule)


    onUnmounted(() => {
      if (store.hasModule(GEOFENCE_DEVICES_STORE_MODULE_NAME))
        store.unregisterModule(GEOFENCE_DEVICES_STORE_MODULE_NAME)
    })


    emit('update:requestStatus', true)

    const fetchDevicesTb = () => {
      requestPending.value = true
      emit('update:requestStatus', true)
      store.dispatch('app-geofence-device/getLinkedBy', {
        user: store.getters['auth/user'].id,
        type: 'device',
        length: perPage.value,
        page: currentPage.value,
        ...filter.value
      }).then(response => {
        //console.log('the out is ',response)
        requestPending.value = false
        devicesTb.value = response.data.data.data
        const { total } = response.data.data
        totalTable.value = total
        if (isAllChecked.value == true) { checkAll(undefined, true) }
        emit('update:requestStatus', false)
      }).catch(res => console.log(res.response))

    }

    fetchDevicesTb()

    store.dispatch('app-geofence-device/devicesAssociated', { geofenceId: geofenceData.value.geofence_id, type: 'geofenceDevices' })
      .then(res => {


        requestIds.value = [... new Set(res.data.ids)]
        devicesAssociated.value = [... new Set(res.data.ids)]
        emit('update:requestStatus', false)
      }).catch(res => { })


    store.dispatch('app-geofence-device/getFilterBy',
      { user: store.getters['auth/user'].id, type: 'device' })
      .then(res => {
        ownersOptions.value = res.data.data.owners
        contractsOptions.value = res.data.data.contracts
        groupsOptions.value = res.data.data.groups
        typesOptions.value = res.data.data.types
        categoriesOptions.value = res.data.data.categories
      }).catch(reason => { })


    const fields = ['name', 'action']

    const submit = () => {

      // console.log(geofenceData.value.geofence_id)
      requestPending.value = true;
      emit('update:requestStatus', true)
      store.dispatch('app-geofence-device/associateDevices', {
        id: geofenceData.value.geofence_id,
        data: [...new Set(requestIds.value)]
      }).then(res => {
        emit('update:requestStatus', false)
        requestPending.value = false;
        toaster('Devices Associated Successfully', 'success', 'success')
      }).catch(reason => {
        requestPending.value = false;
        emit('update:requestStatus', false)
        toaster(root.$t(reason.response.data.errors.devices[0]), 'danger', 'Error')
      })
    }

    const requestIds = ref([])


    const change = (data, value) => {
      const index = requestIds.value.indexOf(data.item.device_id);
      if (value && index === -1) requestIds.value.push(data.item.device_id)
      else requestIds.value.splice(index, 1)

    }




    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    return {
      isAllChecked,
      devicesTb,
      devicesAssociated,
      perPage,
      perPageOptions,
      currentPage,
      searchQuery,
      totalTable,
      dataMeta,
      change,
      checkAll,
      fields,
      submit,
      fetchDevicesTb,
      ownersOptions,
      groupsOptions,
      typesOptions,
      contractsOptions,
      categoriesOptions,

      typeFilter,
      categoryFilter,
      contractFilter,
      ownerFilter,
      groupFilter,

      requestIds,

      //
      requestPending,
      current_selected
    }
  },
}
</script>
